import React, { useEffect, useState } from 'react';
import sellImages from "../../../../assets/images/sell_physical_recharge_plan_id_17_image.png";
import heroImg from "../../../../assets/images/tlsm-model.png";
import bannerImg from "../../../../assets/images/simStockBanner.png";
import axios from 'axios';
import { getApiHeader } from 'utlis/commonfunctions';
import { ThreeDots } from 'react-loader-spinner'
import swal from 'sweetalert';
import cartImg from "../../../../assets/images/shopping_cart.svg";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styled from "@emotion/styled";

const StyledToastContainer = styled(ToastContainer)`
  /* Your styles here */
  .Toastify__toast {
    border-radius: 4px;
    background-color: white;
    height: auto; /* Add a semicolon to separate properties */
    color: black; /* Use "color" instead of "fontColor" */
  }
  .Toastify__toast--success {
  }

  .Toastify__toast--error {
  }
`;

const SERVER_URL = process.env.REACT_APP_API_URL;

const styles = {
  wrapper: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backdropFilter: "blur(1px)",
    zIndex: 9999,
  },
};

function PlanCards({ handleShowCart, handlePage }) {

  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [addedToCart, setAddedToCart] = useState({}); // Object to track added to cart status for each plan

  // To store quantity for each plan dynamically
  const [quantities, setQuantities] = useState({});
  const [totalcount, setTotalCount] = useState("")

  const [cartData, setCartData] = useState({
    retailer_id: sessionStorage.getItem('search-ID'),
    tap_plan_id: "",
    quantity: ""
  });

  useEffect(() => {
    handleSearch();
  }, []);

  // Fetch plans from the server
  const handleSearch = async () => {
    try {
      setLoading(true);
      const header = await getApiHeader();
      const retailer_id = sessionStorage.getItem('search-ID');
      const params = new URLSearchParams();
      params.append('retailer_id', retailer_id);

      const response = await axios.get(`${SERVER_URL}order-free-stock`, {
        headers: header
      });

      if (response.status === 200) {
        const { total_cart_count, postpaid_total_cart_count = 0 } = response.data.data;
        setTotalCount(Number(total_cart_count) + Number(postpaid_total_cart_count));
        const data = response.data.data.plans;
        const postData = Array.isArray(response?.data?.data?.postpaid_plan) && response.data.data.postpaid_plan.length >= 1 
        ? response.data.data.postpaid_plan 
        : [];
      
        const listData = [
           ...data,
           ...postData
        ]

       
        setPlans(listData);


        // Initialize quantities for each plan
        const initialQuantities = {};
        listData.forEach(plan => {
          const type = plan?.type || 'prepaid'; 
           const key = plan?.tap_plan_id + type
           initialQuantities[key] = {
           type,
           quantity: plan?.cart_quantity || 0
         }; // Start with  stock quantity 
        });
        setQuantities(initialQuantities);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error in search request:", error);
    }
  };

  // Increment quantity for a specific plan
const incrementQty = (planId, type) => {
  const key = planId + type;

  setQuantities(prevQuantities => {
    const currentEntry = prevQuantities[key] || { type, quantity: 0 };
    const currentQty = currentEntry.quantity;
     if(type==="postpaid"){
      if (currentQty < 40) {
        const newQty = currentQty + 1;
        return {
          ...prevQuantities,
          [key]: { type, quantity: newQty }
        };
      }


     }else{
      if (currentQty < 30) {
        const newQty = currentQty + 1;
        return {
          ...prevQuantities,
          [key]: { type, quantity: newQty }
        };
      }


     }
    

    return prevQuantities;
  });
};

  const decrementQty = (planId,type) => {
   
  const key = planId + type;
setQuantities(prevQuantities => {
  const currentEntry = prevQuantities[key];

  if (currentEntry && currentEntry.quantity > 0 && currentEntry.type === type) {
    const newQty = currentEntry.quantity - 1;

    return {
      ...prevQuantities,
      [key]: { ...currentEntry, quantity: newQty }
    };
  }

  return prevQuantities;
});


  };

  console.log("quantities--------->",quantities);
  
  // Get the quantity for a specific plan
const getQuantity = (planId, type) => {
  const key = planId + type;
  const entry = quantities[key];
  // console.log("getQuantity--->",entry,entry && entry.type === type,entry?.type,type);
  const entries = entry?.type === type
  return entries ? entry.quantity : 0;
};

  // Handle the "Add to cart" button click
  const handleAddToCart = (planId,type) => {
    const quantity = getQuantity(planId,type); // Get the quantity for the specific plan
    console.log("Selected tap_plan_id", planId, "Quantity:", quantity);

    if (quantity > 0) {
      // Update cartData with planId and quantity
      const updatedCartData = {
        retailer_id: sessionStorage.getItem('search-ID'),
        tap_plan_id: planId,
        quantity: quantity,
        type:type
      };
      setCartData(updatedCartData);

      // Send this `cartData` to the backend via API
      handleCart(updatedCartData, planId);
    } else {
      console.log("Quantity is zero. Cannot add to cart.");
    }
  };

  // Send the cart data to the server
  const handleCart = async (cartData, planId) => {
    try {
      setLoading(true);
      const header = await getApiHeader();
      const response = await axios.post(`${SERVER_URL}order-free-stock/add-to-cart`, cartData, {
        headers: header
      });

      if (response.status === 200) {
        console.log("Item added to cart", response.data.data.cart_count_total);
        setTotalCount(response.data.data.cart_count_total)

        swal({
          // title: "Sucess",
          text: response.data.data.message,
          icon: "success",
          button: "Close"
        });

        // Update `addedToCart` for the specific plan
        setAddedToCart(prevState => ({
          ...prevState,
          [planId]: true // Mark the specific plan as added to cart
        }));
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error adding item to cart:", error);
      swal({
        text: error.response?.data?.message,
        icon: "error",
        button: "Close"
      });
    }
  };

  const handleGoToCart = async () => {
    try {
      setLoading(true)
      if (!totalcount) {
        toast.error("please add items, your cart is empty")
        setLoading(false)
        return
      }
      const header = await getApiHeader();

      const response = await axios.get(`${SERVER_URL}order-free-stock/cart`, {
        headers: header
      });

      if (response.status === 200) {
        const list = [
          ...response?.data?.data?.cart_array,
          ...response?.data?.data?.postpaid_cart_array
        ]
        handleShowCart(true, response.data.data,list);
        handlePage('cart');
      }

      setLoading(false);

    } catch (error) {
      setLoading(false);
       toast.error(error?.response?.data?.message);
      console.error("Error navigating to cart:", error);
    }
  };

  return (
    <>
      {loading && (
        <div style={styles.wrapper}>
          <ThreeDots
            visible={loading}
            height="80"
            width="80"
            color="#C11D6C"
            radius="9"
            ariaLabel="three-dots-loading"
          />
        </div>
      )}
 <StyledToastContainer hideProgressBar={false} position="top-right" autoClose={1000} />
      <div>
        <section id="hero-2" className="hero-2 d-flex align-items-center">
          <div className="container-fluid">
            <div className="hero-border">
              
                <div className="hero-background">
                  <img src={bannerImg} alt="" className="img-fluid banner-img"  style={{ borderRadius:"15px"}}/>
                  </div>
                
            </div>
          </div>
        </section>

        <div className='container'>
          <div>


            <div className="CartStck" onClick={handleGoToCart}>
              <img src={cartImg} />
              <span id="CartCount">{totalcount}</span>
            </div>




          </div>
          <div className='row order-free-cards' style={{  padding: '20px' }}>
            {plans.filter(plan => plan.plan_id !== 19).map((plan, index) => (
              <div className= "col-lg-4 col-md-12 col-sm-12 col-12" key={index}>
                <div className='order-free-stock-recharge-cards'>
                  <img src={plan.plan_image} alt="" className='img-fluid order-free-stock-img' />

                  <div className='plan-details'>
                    <p style={{ fontWeight: '500' }}>{plan.offerName}</p>
                    <span>
                      <p style={{ fontWeight: '900' }}>
                        {Number(plan?.amount) > Number(plan?.sales_amount) && <span style={{ color: 'red', textDecoration: 'line-through' }}>
                          ${plan.amount}
                        </span>}
                        &nbsp;&nbsp;
                        ${plan.sales_amount}
                      </p>
                    </span>

                  </div>

                  <div className='flex order-free-stock-control-box-section '>
                    <div>
                      <button
                        className='order-free-stock-cart-button'
                        onClick={() => handleAddToCart(plan.tap_plan_id,plan?.type)}
                        disabled={getQuantity(plan.tap_plan_id,plan?.type) === 0}
                      >
                         Add to Cart <i class="fa fa-cart-plus" aria-hidden="true"></i>
                      </button>
                    </div>

                    <div className='order-free-stock-control-box'>
                      <button
                        className="btn btn-outline-secondary btn-sm"
                        onClick={() => decrementQty(plan.tap_plan_id,plan?.type)}
                        disabled={getQuantity(plan.tap_plan_id,plan?.type) === 0 }
                      >
                        -
                      </button>
                      <span className="mx-2 value-box">
                        {getQuantity(plan.tap_plan_id,plan?.type)}
                      </span>
                      <button
                        className="btn btn-outline-secondary btn-sm"
                        onClick={() => incrementQty(plan.tap_plan_id,plan?.type)}
                        // disabled={getQuantity(plan.tap_plan_id) >= plan.stock_quantity }
                        disabled={
                          plan?.type === "postpaid"
                            ? getQuantity(plan.tap_plan_id, plan?.type) >= 40
                            : plan.tap_plan_id === 37
                            ? getQuantity(plan.tap_plan_id, plan?.type) >= 40
                            : getQuantity(plan.tap_plan_id, plan?.type) >= 10
                        }
                      >
                        +
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
             <div className='col-lg-11' >
             <br/>
          {totalcount > 0 ?
            <button className="go-to-cart" onClick={handleGoToCart}>
              View Cart <i class="fa fa-shopping-cart"></i>
            </button>
            : ""
          }
             </div>
          </div>


        </div>
      </div>
    </>
  );
}

export default PlanCards;
